// src/components/IndustryInsightsSummaryCard.js
// User Portal card for Industry Insights Summary - placed in Insights tab below Client Profile

import React, { useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    Tooltip,
    IconButton,
    Collapse
} from '@mui/material';
import {
    Analytics as AnalyticsIcon,
    Info as InfoIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon
} from '@mui/icons-material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import IndustryInsightsSummaryModal from './IndustryInsightsSummaryModal';

const IndustryInsightsSummaryCard = () => {
    const { user } = useAuth();   // CHANGED: use `user` instead of `currentUser`
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [isExpanded, setIsExpanded] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [hasMinimumClients, setHasMinimumClients] = useState(false);

     // Fetch industries with at least 2 clients
useEffect(() => {
    console.log('=== IndustryInsightsSummaryCard useEffect STARTED ===');
    console.log('user in card:', user);

    const userId = user?.uid || user?.id || user?.userId;
    console.log('userId resolved in card:', userId);

    const fetchIndustries = async () => {
        if (!userId) {
            console.log('EXITING EARLY in card: No userId');
            return;
        }

        try {
            setIsLoading(true);
            const clientsRef = collection(db, 'clients');
            const q = query(clientsRef, where('fcfoId', '==', userId));
            const snapshot = await getDocs(q);

            console.log('CLIENT SNAPSHOT SIZE (card):', snapshot.size);

            // Build frequency map using industryCanonical (fallback to legacy industry)
            const counts = {};
            snapshot.docs.forEach(doc => {
                const data = doc.data();
                const raw = data.industryCanonical || data.industry;
                const industry = raw && raw.trim();
                if (!industry) return;

                counts[industry] = (counts[industry] || 0) + 1;
            });

            const eligibleIndustries = Object.keys(counts)
                .filter(industry => counts[industry] >= 2)
                .sort();

            console.log('COUNTS:', counts);
            console.log('ELIGIBLE:', eligibleIndustries);
            console.log('HAS MINIMUM:', eligibleIndustries.length > 0);

            setIndustries(eligibleIndustries);
            setHasMinimumClients(eligibleIndustries.length > 0);
        } catch (error) {
            console.error('Error fetching client industries:', error);
        } finally {
            setIsLoading(false);
        }
    };

    fetchIndustries();
}, [user]);

    // Don't render if user has no clients with industries
   // if (!isLoading && industries.length === 0) {
       //  return null;
    // }

    return (
        <>
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            mb: isExpanded ? 1 : 0
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="h6" fontWeight={600}>
                                Industry Insights Summary
                            </Typography>
                            <Tooltip title="Cross-client analysis identifying patterns, challenges, and opportunities across clients in the same industry.">
                                <IconButton size="small">
                                    <InfoIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <IconButton 
                            size="small" 
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>

                    <Collapse in={isExpanded}>
                        <Typography 
                            variant="body2" 
                            color="text.secondary" 
                            sx={{ mb: 2 }}
                        >
                            Analyze patterns across your clients in the same industry. 
                            Identifies common challenges, shared opportunities, and strategic recommendations.
                        </Typography>

                        {hasMinimumClients ? (
                            <Button
                                variant="contained"
                                startIcon={<AnalyticsIcon />}
                                onClick={() => setIsModalOpen(true)}
                                fullWidth
                            >
                                Generate Industry Insights
                            </Button>
                        ) : (
                            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                Requires at least 2 clients in the same industry with assigned industry tags.
                            </Typography>
                        )}
                    </Collapse>
                </CardContent>
            </Card>

            {/* Modal */}
            <IndustryInsightsSummaryModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                industries={industries}
                scope="fcfo"
                user={user}
            />
        </>
    );
};

export default IndustryInsightsSummaryCard;